import { whiteColor, blackLightColor } from '../global';

const productManagementPageStyle = (theme) => ({
    noPadding: {
        padding: 0,
    },
    paperInfoOrder: {
        paddingTop: '20px',
        border: `1px solid ${blackLightColor}`,
        borderRadius: '10px',
    },
    wrapper: {
        backgroundColor: (props) => props?.customColor?.screen_background_color || whiteColor,
    },
    totalNotes: {
        listStyleType: '"※"',
        marginLeft: '-5px',
        paddingLeft: '5px',
    },
    imagePreview: {
        maxWidth: '100%',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    thumbnailImage: {
        width: '75px',
        height: '75px',
        borderRadius: '4px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundPosition: 'center center',
    },
    // for listSeminarViewr
    inputTitle: {
        textAlign: 'right',
        [theme.breakpoints.down('md')]: {
            textAlign: 'left',
        },
    },
    input: {
        width: '100%',
        margin: '10px 0 20px 0',
        [theme.breakpoints.down('md')]: {
            margin: '0 0 20px 0',
        },
    },
    buttonSearch: {
        textAlign: 'right',
        zIndex: 1,
    },
    btnStyle: {
        fontSize: 14,
        minWidth: '100px',
        margin: '10px',
    },
    buttonBig: {
        fontSize: '30px !important',
        minWidth: '400px !important',
        padding: '10px !important',
        margin: '30px !important',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '300px !important',
            margin: '10px  !important',
        },
    },
    dateRangeSearch: {
        paddingLeft: '8px',
        display: 'flex',
        '& > div': {
            flexGrow: 2,
            '& > div': {
                backgroundColor: whiteColor,
            },
            '& label.Mui-focused': {
                color: '#4b4b4b',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: '#4b4b4b',
            },
            '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                    borderColor: '#4b4b4b',
                },
            },
        },
        '& input': {
            color: '#4b4b4b',
        },
    },
    searchLabel: {
        textAlign: 'right',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'left',
        },
    },
    reOrderActionsWrapper: {
        textAlign: 'right',
        marginTop: '20px',
    },
    reOrderCancelBtn: {
        marginRight: '15px',
    },
    reOrderApplyBtn: {

    },
    sectionWrapper: {
        marginBottom: '30px',
    },
    centerToRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    helperText: {
        maxWidth: '480px',
        [theme.breakpoints.down('md')]: {
            maxWidth: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    buttonBig2: {
        fontSize: '30px !important',
        minWidth: '450px !important',
        padding: '10px !important',
        marginBottom: '10px',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '360px !important',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px !important',
            minWidth: '280px !important',
        },
    },
    buttonSmall: {
        fontSize: '24px !important',
        minWidth: '250px !important',
        padding: '5px !important',
        margin: '10px !important',
        borderRadius: '10px',
    },
    room: {
        border: '1px solid rgb(169, 169, 169)',
        borderRadius: '13px',
        padding: '0 20px',
    },
    roomMobile: {
        border: '1px solid rgb(169, 169, 169)',
        borderRadius: '13px',
    },
    titleDetail: {
        paddingTop: '15px',
    },
    titlePrice: {
        paddingTop: '20px',
        paddingBottom: '20px',
        borderTop: '1px solid rgb(169, 169, 169)',
    },
    payment: {
        marginLeft: '35px',
        marginTop: '20px',
    },
    paymentMarginTop: {
        marginTop: '20px',
        padding: 0,
    },
    radioButton: {
        marginLeft: '120px',
        '& > span': {
            color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
        },
        '& .Mui-checked': {
            color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
        },
        '@media (max-width: 500px)': {
            marginLeft: 0,
            '& > span': {
                color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
            },
            '& .Mui-checked': {
                color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
            },
        },
    },
    colorIconRadio: {
        '& > span': {
            color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
        },
        '& .Mui-checked': {
            color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
        },
    },
    leftTitle: {
        textAlign: 'left',
        paddingRight: '46px',
    },
    rightInput: {
        marginBottom: '15px',
    },
    rightSelect: {
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center',
        '& > div': {
            width: '35%',
        },
    },
    rightSelectNoMargin: {
        display: 'flex',
        alignItems: 'center',
        '& > div': {
            width: '35%',
        },
    },
    titleMonth: {
        display: 'block',
        marginRight: '30px',
        marginLeft: '10px',
        color: (props) => props?.customColor?.contents_text_color || props?.contents_text_color,
    },
    titleYear: {
        display: 'block',
        marginLeft: '10px',
        color: (props) => props?.customColor?.contents_text_color || props?.contents_text_color,
    },
    customTable: {
        maxHeight: '400px',
    },
    colorTextInput: {
        '& input': {
            color: '#4b4b4b',
        },
        '& > div': {
            backgroundColor: whiteColor,
        },
        '& label.Mui-focused': {
            color: '#4b4b4b',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#4b4b4b',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#4b4b4b',
            },
        },
    },
    dateRangeArea: {
        marginTop: 'auto',
        marginBottom: 'auto',
        color: (props) => props?.customColor?.contents_text_color || props?.contents_text_color,
    },
    loadMore: {
        align: 'center',
        marginTop: '20px',
    },
    listButton: {
        textAlign: 'center',
        position: 'relative',
    },
    buttonView: {
        position: 'absolute',
        right: '0',
        bottom: '0',
    },
    buttonExit: {
        marginBottom: '50px',
    },
    roomView: {
        padding: '70px 20px 0',
        marginBottom: '50px',
        width: '100%',
        backgroundColor: (props) => props?.eventInfo?.settings_colors_viewer?.screen_background_color || '#fff',
    },
    disableHover: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    noPaddingOrder: {
        padding: '20px 0 0 0',
    },
});

export default productManagementPageStyle;
